<template>
  <div>
    <b-button
      v-b-toggle.collapse-simple-filter
      variant="link"
    >
      Visualizar Filtros
    </b-button>
    <b-collapse
      id="collapse-simple-filter"
      class="ml-5 mr-5 mt-3 mb-3"
    >
      <h3>{{ $t('dexpara.filtros.titulo') }}</h3>
      <div class="row">
        <b-form-group :label="$t('dexpara.filtros.nome')" label-for="input-nome" class="col-md-3">
          <b-form-input id="input-nome" v-model="filters.name" @change="evt => setFilter('name', evt)" @keyup.enter="e=>{e.preventDefault(); $emit('search')}"/>
        </b-form-group>

        <b-form-group :label="$t('dexpara.filtros.codigo')" label-for="input-codigo" class="col-md-3">
          <b-form-input id="input-codigo" v-model="filters.code_mapping" @change="evt => setFilter('code_mapping', evt)" @keyup.enter="e=>{e.preventDefault(); $emit('search')}"/>
        </b-form-group>

        <b-form-group :label="$t('dexpara.filtros.integracao')" label-for="input-integracao" class="col-md-3">
          <SelectComponent
              id="input-integracao"
              :searching="store_integrations_isLoading"
              :options="integrations | idNameToValueLabel"
              @search="evt => autocomplete('integration/search', evt)"
              @input="evt => setFilter('integration', evt)"
          />
        </b-form-group>
        <div class="col-md-3 d-flex align-items-center">
          <b-button id="btn-filter" variant="primary" class="w-100 mt-3" @click="$emit('search')">
            <i class="fas fa-search mr-2"/> {{ $t('dexpara.filtros.botao_filtrar') }}
          </b-button>
        </div>
      </div>    
    </b-collapse>
  </div>
</template>

<script>
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "DeXParaSimpleFilter",
  components: {SelectComponent},
  computed: {
    ...mapGetters({
      integrations: 'integration/all',
      store_integrations_isLoading: 'integration/isLoading'
    })
  },
  data() {
    return {
      show_filter: false,
      filters: {
        name: null,
        code_mapping: null,
        integration: null
      }
    }
  },
  methods: {
    ...mapActions([
      'integration/search'
    ]),
    async autocomplete(entityString, string) {
      if (string.length >= 3) {
        // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
        this.temporallyStringPrepareToSQL('name', string).map(async array => {
          await this[entityString]({filters: [array], aggregate: true})
        })
      }
    },
    // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
    temporallyStringPrepareToSQL(field, valueTyped) {
      return [
        [field, 'LIKE', '%' + valueTyped.toUpperCase() + '%'],
        [field, 'LIKE', '%' + valueTyped.toLowerCase() + '%'],
        [field, 'LIKE', '%' + valueTyped.charAt(0).toUpperCase() + valueTyped.slice(1) + '%'],
      ]
    },
    setFilter(key, value) {
      this.filters[key] = value
      if (value && value.value) {
        this.filters[key] = value.value
      }
      this.sanitizeFilters()
    },
    sanitizeFilters() {
      let sanitizedFilters = []
      for (var [key, value] of Object.entries(this.filters)) {
        if (value) {
          if (key === 'name') {
            sanitizedFilters = [...sanitizedFilters, [key, 'LIKE', '%' + value + '%']]
            continue;
          }

          sanitizedFilters = [...sanitizedFilters, [key, '=', value]]
        }
      }
      this.$store.commit('dexpara/setFilters', sanitizedFilters)
    }
  }
}
</script>
